export const BOT_MESSAGE_DELAY = 400
export const FIRST_NODE_ID = "START"
